const DELIVERY_OPTION_TYPES = {
    SHIPPED: 'shipped',
    SAME_DAY: 'sameDay',
    PICKUP: 'pickup',
    AUTO_REPLENISH: 'autoReplenish'
};

const BOPIS_WARNING_KEY = 'productgraph.liteProduct.bopis.notFound';

export {
    DELIVERY_OPTION_TYPES,
    BOPIS_WARNING_KEY
};
